import {
  getAllQuestionData
} from '@/utils/auth'
const getters = {
  component: state => state.component,
  moduleStatus: state => state.moduleStatus,
  module: state => state.module,
  topic: state => state.topic,
  userInfo: state => state.userInfo,
  isLoading: state => state.isLoading,
  wapAllQuestion: state => state.wapAllQuestion,
  qTime: state => state.qTime,
  questionId: state => state.questionId,
  showVideoTip: state => state.showVideoTip,
  showNoticeTip: state => state.showNoticeTip,
  showTimeoutNotice: state => state.showTimeoutNotice,
  shareData: state => state.shareData,
  stopTimer: state => state.stopTimer,
  routeName: state => state.routeName,
  allQuestion: getAllQuestionData,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js